import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "AIpopupBox" }
const _hoisted_2 = { class: "AIpopupTip" }
const _hoisted_3 = { class: "AIpopupNotice" }
const _hoisted_4 = { class: "AIpopupBtn" }

import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'AIpopup',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    },
    cancelShow: {
        type: Boolean,
        default: true
    },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const tips = ['正在初始化分析引擎...',
    '正在处理数据...',
    '正在应用智能算法...',
    '正在生成分析...',
    '正在优化结果...',
    '即将完成...'
]
const notices = [
    '✨ 这本书将带来什么改变？',
    '•	✅ 思维升级：从“套模板”到“创意思维”，写出独一无二的个性作文；',
    '•	✅ 效率提升：快速突破“没素材”“没灵感”的瓶颈，下笔如有神；',
    '•	✅ 素养奠基：通过写作培养观察力、逻辑力、表达力，助力全科学习！',
    '•	“教材不是学生的世界，世界才是最好的教材!” 让作文真正扎根于生活，写出有血有肉的真情实感。',
    '•	书中融入AI技术辅助素材整理和框架设计，但始终强调“深度思想与情感无法被AI取代”，避免学生依赖科技而丧失创造力。'
]
const props = __props
const dialogShow = ref(props.popupShow)
const tipActive = ref('')
const noticeActive = ref('')
let timer = null, noticetimer = null;
const emitList = __emit

function cancelHandle() {
    emitList('close')
}

onMounted(() => {
    let n = 0, noticeNum = 0
    tipActive.value = tips[n]
    noticeActive.value = notices[noticeNum]
    timer = setInterval(() => {
        n++;
        if (n < tips.length) {
            tipActive.value = tips[n]
        } else {
            timer && clearInterval(timer)
            timer = null
        }
    }, 2000)
    noticetimer = setInterval(() => {
        noticeNum++;
        if (noticeNum < notices.length) {
            noticeActive.value = notices[noticeNum]
        } else {
            noticetimer && clearInterval(noticetimer)
            noticetimer = null
        }
    }, 3000)
})
onBeforeUnmount(() => {
    timer && clearInterval(timer)
    timer = null
    noticetimer && clearInterval(noticetimer)
    noticetimer = null
})

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogShow).value = $event)),
    title: "开悟作文智能分析",
    width: "400px",
    center: "",
    "close-on-click-modal": false,
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(tipActive.value), 1),
          _createVNode(_component_el_icon, { color: "#ef8b25" }, {
            default: _withCtx(() => [
              _createVNode(_component_Loading)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(noticeActive.value), 1),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            icon: "close",
            style: {"width":"100%"},
            type: "info",
            color: "#dadbde",
            round: "",
            onClick: cancelHandle
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("取消操作")
            ])),
            _: 1,
            __: [1]
          })
        ], 512), [
          [_vShow, __props.cancelShow]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})